<template>
  <q-dialog v-model="visible" full-height position="right">
    <q-card class="full-card" style="width: 80vw !important">
      <q-toolbar class="auto-height">
        <q-toolbar-title class="q-pa-sm" style="padding-left: 0px"> フレックスメッセージテンプレート </q-toolbar-title>
        <div class="row q-gutter-md items-center q-mr-md">
          <q-btn
            no-caps
            dense
            class="btn-upload"
            label="現在の編集内容をテンプレートとして追加"
            @click="onAdd"
            v-if="isSuper || (isAdmin && bar === 'custom')"
          />
          <q-input outlined dense v-model="search" @keyup.enter="onSearchTemplate" label="テンプレート名で検索">
            <template v-slot:append>
              <q-icon name="search" color="text-prey-3" @click="onSearchTemplate" />
            </template>
          </q-input>
        </div>
      </q-toolbar>
      <q-card-section>
        <CLoading :loading="loading" />
        <div class="max-height-dialog">
          <q-tabs
            no-caps
            dense
            align="left"
            v-model="tabs"
            class="text-grey"
            active-color="black"
            indicator-color="black"
          >
            <q-tab name="standard" label="標準テンプレート" />
            <q-tab name="custom" label="カスタムテンプレート" />
          </q-tabs>
          <q-table
            bordered
            flat
            dense
            :rows="templates"
            row-key="title"
            :rows-per-page-options="[10]"
            separator="cell"
            :no-data-label="$t('messages.no_data_available')"
            class="text-grey-8"
            :key="componentKey"
          >
            <template v-slot:header="">
              <q-tr>
                <q-th key="name" style="width: 100px"></q-th>
                <q-th key="name" style="width: 160px"></q-th>
                <q-th key="name">
                  <span class="text-bold">{{ $t('label.flex_message_template.template_name') }}</span>
                </q-th>
                <q-th key="description">
                  <span class="text-bold">{{ $t('label.flex_message_template.template_description') }}</span>
                </q-th>
                <q-th key="type" style="width: 150px">
                  <span class="text-bold">{{ $t('label.flex_message_template.template_type') }}</span>
                </q-th>
                <q-th key="_id" style="width: 25px; text-align: center !important">|</q-th>
                <q-th key="is_video" style="width: 100px">
                  <span class="text-bold">{{ $t('label.flex_message_template.presence_video') }}</span>
                </q-th>
                <q-th key="is_image" style="width: 100px">
                  <span class="text-bold">{{ $t('label.flex_message_template.presence_image') }}</span>
                </q-th>
                <q-th key="is_button" style="width: 100px">
                  <span class="text-bold">{{ $t('label.flex_message_template.presence_button') }}</span>
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr
                :props="props"
                :index="props.rowKey"
                :class="props.row._id === chooseTemplate._id ? 'selected' : ''"
              >
                <q-td key="name" :props="props" style="text-align: center !important">
                  <q-btn
                    dense
                    unelevated
                    :class="props.row._id === chooseTemplate._id ? 'btn-save' : 'btn-cancel'"
                    label="選択"
                    padding="0px 24px"
                    @click="onSelectTemplate(props.row)"
                  />
                </q-td>
                <q-td key="name" :props="props">
                  <div class="image-container q-py-xs" @mouseenter="onHover(props.row)" @mouseleave="onLeave">
                    <img :src="props.row.img" class="hover-img" />
                  </div>
                </q-td>
                <q-td key="name" :props="props">
                  <span>
                    {{ props.row.name.length > 25 ? props.row.name.slice(0, 4) + '...' : props.row.name }}
                  </span>
                  <q-btn
                    size="sm"
                    flat
                    round
                    icon="edit"
                    @click="onEdit(props.row)"
                    v-if="isSuper || (tabs === 'custom' && isAdmin)"
                  />
                  <q-btn
                    size="sm"
                    flat
                    round
                    color="red"
                    icon="mdi-trash-can"
                    @click="onDelete(props.row)"
                    v-if="isSuper || (tabs === 'custom' && isAdmin)"
                  />
                  <br />
                  <span class="q-mt-sm">
                    {{ props.row._id.length > 4 ? props.row._id.slice(0, 4) + '***' : props.row._id }}
                  </span>
                </q-td>
                <q-td key="description" :props="props">
                  <span style="text-wrap: auto">{{ props.row.description }}</span>
                </q-td>
                <q-td key="type" :props="props">
                  <q-chip class="btn-cancel">
                    {{ $t('label.flex_message_template.' + props.row.type) }}
                  </q-chip>
                </q-td>
                <q-td key="_id" class="text-center">|</q-td>
                <q-td key="is_video" :props="props">
                  <q-chip class="presence-tag" :class="props.row.is_video ? 'btn-save' : 'btn-save-grey'">
                    {{
                      props.row.is_video ? $t('label.flex_message_template.yes') : $t('label.flex_message_template.no')
                    }}
                  </q-chip>
                </q-td>
                <q-td key="is_image" :props="props">
                  <q-chip class="presence-tag" :class="props.row.is_image ? 'btn-save' : 'btn-save-grey'">
                    {{
                      props.row.is_image ? $t('label.flex_message_template.yes') : $t('label.flex_message_template.no')
                    }}
                  </q-chip>
                </q-td>
                <q-td key="is_button" :props="props">
                  <q-chip class="presence-tag" :class="props.row.is_button ? 'btn-save' : 'btn-save-grey'">
                    {{
                      props.row.is_button ? $t('label.flex_message_template.yes') : $t('label.flex_message_template.no')
                    }}
                  </q-chip>
                </q-td>
              </q-tr>
            </template>
          </q-table>
          <div
            class="flex-message-content"
            v-if="hoverImg"
            :style="{
              top: hoverY + 'px',
              left: hoverX + 'px',
            }"
          >
            <img :src="hoverImg" class="hover-img" />
          </div>
        </div>
        <div class="row no-wrap items-center q-my-md q-pr-md">
          <q-space />
          <div class="q-gutter-sm">
            <q-btn no-caps flat class="btn-cancel" @click="onCancel">{{ $t('cancel') }} </q-btn>
            <q-btn no-caps class="btn-save" @click="onSubmit"> {{ $t('save') }} </q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
  <FlexMessageTemplateFormModal
    v-if="templateModalVisible"
    :modalVisible="templateModalVisible"
    :template="selectedTemplate"
    :previewImageUrl="previewImageUrl"
    :imgFile="imgFile"
    :appId="appId"
    :isMessageChanged="isMessageChanged"
    :isAdmin="isAdmin"
    :isSuper="isSuper"
    :type="tabs"
    :altText="altText"
    @update:closeModal="onCloseModal"
    @updateTemplates="loadTemplates"
    @update:altText="(val) => $emit('update:altText', val)"
  />
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import { maska } from 'maska'
import { IFlexMessageBubble, IFlexMessageCarousel, IFlexMessageTemplate } from '@/utils/types'
import CLoading from '@/components/common/ui/CLoading.vue'
import FlexMessageTemplateFormModal from '@/components/story/common/flex-message/FlexMessageTemplateFormModal.vue'
import { Prop, Watch } from 'vue-property-decorator'
import { ACTION_FLEX_MESSAGE_TEMPLATE } from '@/store/actions'

@Options({
  components: { FlexMessageTemplateFormModal, CLoading },
  directives: { maska },
  emits: ['update:selectTemplate', 'onAddTemplate', 'update:altText'],
})
export default class FlexMessageTemplateModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  template!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  previewImageUrl!: string

  @Prop()
  imgFile!: File

  @Prop()
  isMessageChanged!: boolean

  @Prop()
  isAdmin!: boolean

  @Prop()
  isSuper!: boolean

  @Prop()
  altText!: string

  templates: IFlexMessageTemplate[] = []
  standardTemplates: IFlexMessageTemplate[] = []
  customTemplates: IFlexMessageTemplate[] = []
  selectedTemplate: IFlexMessageTemplate = {}
  chooseTemplate: IFlexMessageTemplate = {}
  loading = true
  search = ''
  templateModalVisible = false
  hoverId = ''
  hoverImg = ''
  hoverX = 0
  hoverY = 0
  bar = 'standard'
  componentKey = 1

  get tabs() {
    return this.bar
  }

  set tabs(tab: string) {
    this.bar = tab
  }

  get appId() {
    return this.$route.params.app_id as string
  }

  async onSearchTemplate() {
    this.loading = true
    await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.LOAD_ITEMS, {
      app_id: this.appId,
      template_type: this.tabs,
      filter: {
        name: this.search,
      },
    })
    this.loading = false
  }

  onSelectTemplate(item: IFlexMessageTemplate) {
    this.chooseTemplate = item
  }

  onAdd() {
    if (this.template === undefined || this.template === null) {
      this.$q.notify({
        message: 'Template is not defined. Please create a template first.',
        color: 'negative',
      })
      return
    }
    this.selectedTemplate = {}
    this.selectedTemplate.contents = this.template
    this.templateModalVisible = true
    this.$emit('onAddTemplate')
  }

  onEdit(message: IFlexMessageTemplate) {
    this.selectedTemplate = message
    this.templateModalVisible = true
  }

  async onDelete(template: IFlexMessageTemplate) {
    this.$q
      .dialog({
        title: this.$t('confirm'),
        message: this.$t('are_you_sure_you_want_to_delete'),
        cancel: true,
        persistent: true,
      })
      .onOk(async () => {
        const success = await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.DELETE, template._id)
        if (success) {
          this.$q.notify({
            message: this.$t('messages.deleted'),
            color: 'positive',
          })
          await this.loadTemplates()
        }
      })
  }

  onCloseModal() {
    this.selectedTemplate = {}
    this.templateModalVisible = false
  }

  onSubmit() {
    this.$emit('update:selectTemplate', this.chooseTemplate)
  }

  onHover(row) {
    this.hoverId = row._id
    this.hoverImg = row.img
    document.addEventListener('mousemove', this.onMouseMove)
  }

  onLeave() {
    this.hoverId = ''
    this.hoverImg = ''
    document.removeEventListener('mousemove', this.onMouseMove)
  }

  onMouseMove = (e: MouseEvent) => {
    this.hoverX = e.clientX + 10
    this.hoverY = e.clientY - 100
  }

  @Watch('tabs')
  @Watch('standardTemplates')
  @Watch('customTemplates')
  fetchTemplates() {
    if (this.tabs === 'standard') {
      this.templates = this.standardTemplates
    } else {
      this.templates = this.customTemplates
    }
    this.componentKey++
  }

  async loadTemplates() {
    this.standardTemplates = await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.LOAD_ITEMS, {
      app_id: this.appId,
      template_type: 'standard',
    })
    this.customTemplates = await this.$store.dispatch(ACTION_FLEX_MESSAGE_TEMPLATE.LOAD_ITEMS, {
      app_id: this.appId,
      template_type: 'custom',
    })
  }

  async mounted() {
    await this.loadTemplates()
    this.templates = this.standardTemplates
    this.loading = false
  }
}
</script>

<style scoped lang="scss">
.selected {
  background-color: #3982c233;
}

.selected .text-subtitle2 {
  color: #6fb1eb;
}
.q-toolbar.auto-height .q-toolbar__title:first-child {
  border-bottom: none;
}

:deep(.q-chip.btn-cancel) {
  width: 120px;
}
:deep(.q-chip.btn-cancel .q-chip__content) {
  justify-content: center;
}

:deep(.q-chip.presence-tag) {
  width: 80px;
}
:deep(.q-chip.presence-tag .q-chip__content) {
  justify-content: center;
}

.image-container {
  position: relative;
  display: inline-block;
  width: 150px;
  height: 75px;
  background-color: #7491bd;
}
.flex-message-content {
  background-color: #7491bd;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 600px;
  padding: 10px;
  position: fixed;
  z-index: 9999;
  border: 1px solid #ccc;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  overflow: hidden;
}
.hover-img {
  object-fit: contain !important;
  width: 100%;
  height: 100%;
}

:deep(.q-tab--active) {
  background-color: #ffffff;
}
:deep(.q-table th) {
  text-align: left !important;
}
</style>
